var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.61 33.39C70.73 49.51 79.05 67.33 73.18 73.19C67.32 79.05 49.5 70.74 33.38 54.62C17.27 38.49 8.95 20.67 14.81 14.81C20.67 8.95 38.49 17.26 54.61 33.38V33.39ZM73.19 14.81C62.2 3.82 50.61 -2.42 47.32 0.879999C44.03 4.18 50.26 15.76 61.25 26.75C72.24 37.74 83.82 43.98 87.12 40.68C90.42 37.38 84.18 25.8 73.19 14.81ZM0.879999 47.32C-2.42 50.62 3.82 62.2 14.81 73.19C25.8 84.18 37.38 90.42 40.68 87.12C43.98 83.82 37.74 72.24 26.75 61.25C15.76 50.26 4.18 44.02 0.879999 47.32Z",
    fill: "#6D247A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon13);
export default __webpack_public_path__ + "static/media/icon_13.efb75343fbaa4ae04631fc1163ed99c6.svg";
export { ForwardRef as ReactComponent };